import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Container as ContainerBase } from "components/misc/Layouts.js";
import logo from "images/papelerialeo-logo.png";
import { ReactComponent as FacebookIcon } from "../../images/facebook-icon.svg";
import { ReactComponent as InstagramIcon } from "images/instagram-icon.svg";

const Container = tw(ContainerBase)`bg-primary-900 text-gray-100 -mx-8 -mb-8`;
const Content = tw.div`max-w-screen-xl mx-auto py-10 lg:py-10`;
const Row = tw.div`flex items-center justify-center flex-col px-8`;
const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-40 py-1 bg-white rounded-md`;
const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`;
const Link = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;
const SocialLinksContainer = tw.div`mt-10`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block text-gray-100 hover:text-gray-500 transition duration-300 mx-4`}
  svg {
    ${tw`w-5 h-5`}
  }
`;

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`;
export default () => {
  return (
    <Container>
      <Content>
        <Row>
          <LogoContainer>
            <Link href="/">
              <LogoImg src={logo} />
            </Link>
          </LogoContainer>
          <LinksContainer>
            <Link href="/">Inicio</Link>
            <Link href="/quienes-somos">¿Quiénes somos?</Link>
            <Link href="/papeleria">Papelería</Link>
            <Link href="/tramites-digitales">Trámites Digitales</Link>
            <Link href="/servicios">Servicios</Link>
            <Link href="/contacto">Contacto</Link>
          </LinksContainer>
          <SocialLinksContainer>
            <SocialLink
              href="https://instagram.com/leo.papeleria"
              target="_blank"
              rel="noreferrer"
            >
              <InstagramIcon />
            </SocialLink>
            <SocialLink
              href="https://facebook.com/papelerialeoslp"
              target="_blank"
              rel="noreferrer"
            >
              <FacebookIcon />
            </SocialLink>
          </SocialLinksContainer>
          <CopyrightText>
            {new Date().getFullYear()} Papelería e internet leo
          </CopyrightText>
        </Row>
      </Content>
    </Container>
  );
};
